module.exports = __webpack_public_path__ + "media/images/brightpearl-logo-533db933.svg";